export const SAVE_EVENT = 'saveEvent'
export const FETCH_EVENT = 'fetchEvent'
export const UPDATE_EVENT = 'updateEvent'
export const REMOVE_EVENT = 'removeEvent'

export const FETCH_OFFDATES = 'fetchOffdates'
